import PropTypes from 'prop-types';
import HighCharts from '../HighCharts';

import s from './HeatMapBlock.module.css';

const HeatMapBlock = ({
    title,
    displayLargeTitle,
    showTitleInToc,

    xAxisLabel,
    xAxisLabelFormattting,
    xAxisCategorySortingType,
    xAxisCategoryOrdering,

    yAxisLabel,
    yAxisLabelFormattting,
    yAxisCategorySortingType,
    yAxisCategoryOrdering,

    decimalPlaces,

    colorScheme,

    propertySeriesQueries,
}) => {
    return (
        <div className={s.Root}>
            <HighCharts
                chartType="heatmap"
                title={title}
                showTitleInToc={showTitleInToc}
                displayLargeTitle={displayLargeTitle}
                xAxisLabel={xAxisLabel}
                xAxisLabelFormattting={xAxisLabelFormattting}
                xAxisCategorySortingType={xAxisCategorySortingType}
                xAxisCategoryOrdering={xAxisCategoryOrdering}
                yAxisLabel={yAxisLabel}
                yAxisLabelFormattting={yAxisLabelFormattting}
                yAxisCategorySortingType={yAxisCategorySortingType}
                yAxisCategoryOrdering={yAxisCategoryOrdering}
                decimalPlaces={decimalPlaces}
                colorScheme={colorScheme}
                propertySeriesQueries={propertySeriesQueries}
            />
        </div>
    );
};

HeatMapBlock.propTypes = {
    title: PropTypes.string,
    displayLargeTitle: PropTypes.bool,
    showTitleInToc: PropTypes.bool,

    xAxisLabel: PropTypes.string,
    xAxisLabelFormattting: PropTypes.string,
    xAxisCategorySortingType: PropTypes.string,
    xAxisCategoryOrdering: PropTypes.string,

    yAxisLabel: PropTypes.string,
    yAxisLabelFormattting: PropTypes.string,
    yAxisCategorySortingType: PropTypes.string,
    yAxisCategoryOrdering: PropTypes.string,

    decimalPlaces: PropTypes.number,

    colorScheme: PropTypes.string,

    propertySeriesQueries: PropTypes.array,
};

export default HeatMapBlock;
